exports = module.exports = require("./../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{padding-top:0}.navbar-default,nav .navbar-header .navbar{height:40px!important}.navbar-toggle{background-color:transparent}.navbar-toggle:active,.navbar-toggle:focus,.navbar-toggle:hover{background-color:transparent!important}.navbar{border:0;height:40px!important;border-radius:0!important;margin-bottom:0;margin-top:0;background-color:#34495e}.navbar-brand{font-weight:700}.navbar-collapse{border-color:transparent!important;border-top:0!important;background-color:#34495e;margin-top:5px}.navbar-brand>img{height:40px;position:absolute;top:2px}.navbar-default .navbar-nav>li>a{padding-bottom:5px;color:#bbb}.navbar-toggle{border-color:transparent!important}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#fff;text-decoration:none;background-color:transparent;visibility:visible;-webkit-transition:.2s;transition:.2s}.navbar-nav{float:right;border-radius:0!important}@media (max-width:768px){.navbar-nav{float:left;width:100%;border-radius:0!important}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/css-loader!./~/sass-loader/lib/loader.js!./~/react-scripts/~/postcss-loader!./src/css/base.scss
 ** module id = 524
 ** module chunks = 0
 **/